import { render, staticRenderFns } from "./shops.vue?vue&type=template&id=228d92b6&scoped=true&"
import script from "./shops.vue?vue&type=script&lang=js&"
export * from "./shops.vue?vue&type=script&lang=js&"
import style0 from "./shops.vue?vue&type=style&index=0&id=228d92b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228d92b6",
  null
  
)

export default component.exports